import ServicePrimeTransfer from"./ServicePrimeTransfer";export default ServicePrimeTransfer;